package com.example.mystybag.core.extensions

import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

fun Instant?.toMilliseconds() : Long  = this?.toEpochMilliseconds() ?: 0

fun Long.toDateInstant() : Instant = Instant.fromEpochMilliseconds(this)

fun Instant.isToday() : Boolean {
    val userTimeZone = TimeZone.currentSystemDefault()
    val nowLocalDateTime    = Clock.System.now().toLocalDateTime(userTimeZone)
    val localDateTime       = this.toLocalDateTime(userTimeZone)

    return nowLocalDateTime.year == localDateTime.year && nowLocalDateTime.month == localDateTime.month
            && nowLocalDateTime.dayOfMonth == localDateTime.dayOfMonth
}

fun Instant.isYesterday() : Boolean {
    val userTimeZone = TimeZone.currentSystemDefault()
    val nowLocalDateTime    = Clock.System.now().toLocalDateTime(userTimeZone)
    val localDateTime       = this.toLocalDateTime(userTimeZone)

    return nowLocalDateTime.year == localDateTime.year && nowLocalDateTime.month == localDateTime.month
            && nowLocalDateTime.dayOfMonth - localDateTime.dayOfMonth == 1
}

fun Instant.isAtTheSameDay(instant: Instant) : Boolean {
    val userTimeZone = TimeZone.currentSystemDefault()
    val firstLocalDateTime        = instant.toLocalDateTime(userTimeZone)
    val secondLocalDateTime       = this.toLocalDateTime(userTimeZone)

    return firstLocalDateTime.year == secondLocalDateTime.year && firstLocalDateTime.month == secondLocalDateTime.month
            && firstLocalDateTime.dayOfMonth == secondLocalDateTime.dayOfMonth
}

fun Instant.toVignetteDateString() =
    this.toLocalDateTime(TimeZone.currentSystemDefault()).let { localDateTime ->
        "${localDateTime.dayOfMonth}.${(localDateTime.month.ordinal + 1).toString().padStart(2, '0')}.${localDateTime.year}"
    }